document.querySelector('.forgot-trigger').onclick = function (event) {
  event.preventDefault()
  document.querySelector('#forgot').classList.add('active')
  document.querySelector('#login').classList.remove('active')
}

document.querySelector('.login-trigger').onclick = function (event) {
  event.preventDefault()
  document.querySelector('#login').classList.add('active')
  document.querySelector('#forgot').classList.remove('active')
}

const passwordField = document.querySelector('.js-password');
const eyeIcon = document.querySelector('.js-eye');
eyeIcon.addEventListener('click', (event) => {
  if (passwordField.type === "password") {
    passwordField.type = "text";
    eyeIcon.classList.add('active');
    eyeIcon.ariaLabel = 'Hide password'

  } else {
    passwordField.type = "password";
    eyeIcon.classList.remove('active');
    eyeIcon.ariaLabel = 'Show password'
  }
})

if (window.location.hash) {
  if (window.location.hash.indexOf('recover') == 1) {
    document.querySelector('#forgot').classList.add('active')
    document.querySelector('#login').classList.remove('active')
  } else {
    document.querySelector('#forgot').classList.remove('active')
    document.querySelector('#login').classList.add('active')
  }
}
